<script lang="ts">
	import { page } from "$app/stores";
</script>

<div class="flex flex-col justify-center w-full py-12">
	<h1 class="text-base mb-4 text-gray-400">Error</h1>
	<h1 class="text-5xl font-bold">{$page.status}</h1>
	<h2 class="mt-4 text-gray-400">{$page.error?.message}</h2>
</div>
